'use client';

import DynamicTitle from "@/components/elements/texts/DynamicTitle/DynamicTitle";
import DetailPagePagination from "@/components/objects/DetailPagePagination/DetailPagePagination";
import useFetchContentDetail from "@/hooks/useFetchContentDetail.hooks";
import parse from "html-react-parser";
import { redirect, useSearchParams } from "next/navigation";
import { Suspense, useEffect } from "react";
import { Meta } from "../../_configs/SiteInfo";
import styles from "./VoiceDetailTemplate.module.scss";
import { VoiceDetailTemplateType } from "./VoiceDetailTemplate.types";

const VoiceDetailTemplate = (props: VoiceDetailTemplateType) => {
  const {microCMSAuth, endpointId} = props;

  const searchParams = useSearchParams();
  const contentId = searchParams?.get("id") || "";
  const draftKey = searchParams?.get("draftKey") || '';

  if (!contentId) {
    redirect(`../`);
  }

  const microCMSQuery = {
    endpointId: endpointId,
    contentId: contentId,
    draftKey: draftKey
  };

  const {isLoading, response, hasError, errorMessage} = useFetchContentDetail(microCMSAuth, microCMSQuery);

  useEffect(() => {
    if (response) {
      document.title = response.title + " | " + Meta.siteName;
      document.querySelector('meta[name="description"]')?.setAttribute("content", response.title + " | " + Meta.siteName);
    }

    const canonicalUrl = window.location.href;

    let link = document.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonicalUrl);

  }, [response, searchParams, contentId, isLoading])

  if (isLoading) {
    return (
        <></>
    );
  };

  if (hasError) {
    return (
      <p style={{textAlign: "center"}}>{errorMessage}</p>
    );
  }
  return (
    <Suspense>
      {response ? (
        <>
          <DynamicTitle tag={"h2"} text={response.title} />
          <div className={"microcms-post"}>
            <div className={styles.voice__info}>
              <p className={styles.voice__name}>
                {response.name && parse(`${response.name} 様`)} {response.old.length != 0 && parse(`（${response.old}）`)}
              </p>
              {response.address &&
                <div className={styles.voice__addrewss}>{response.address}在住</div>
              }
            </div>
            {response.eyecatch && 
              <div className={`${styles.voice__eyecatch} ${styles.voice__box}`}>
                <img className={styles['shop-voices-item__eyecatch']} src={`${response.eyecatch.url}?fm=webp`} alt={response.title} />
              </div>
            }
            {response.reason &&
              <div className={`${styles.voice__reason} ${styles.voice__box}`}>
                <h3 className={styles.voice__detail__title}>ご来院の理由</h3>
                <div className={styles.voice__reason__text}>
                  {parse(response.reason)}
                </div>
              </div>
            }
            {response.thoughts &&
              <div className={`${styles.voice__thoughts} ${styles.voice__box}`}>
                <h3 className={styles.voice__detail__title}>ご来院の理由</h3>
                <div className={styles.voice__thoughts__text}>
                  {parse(response.thoughts)}
                </div>
              </div>
            }
            {response.comment && 
              <div className={`${styles.voice__comment} ${styles.voice__box}`}>
                <h3 className={styles.voice__detail__title}>整骨院からのコメント</h3>
                <div className={styles.voice__comment__text}>
                  {parse(response.comment)}
                </div>
              </div>
            }
            {response.content &&
              <div className={`${styles.voice__content} ${styles.voice__box}`}>
                {parse(response.content)}
              </div>
            }
            
          </div>
          <DetailPagePagination
            microCMSAuth={microCMSAuth}
            endpointId={endpointId}
            contentId={contentId}
          />
        </>
      ) : null}
      </Suspense>
  )
}

export default VoiceDetailTemplate;